<div class="flex flex-row items-center gap-0">
  @if (totalPages() <= maxPageButtons) {
    <!-- We can show all of the page buttons at once, without any dots or separation. -->
    @for (page of middlePages(); track page) {
      <ng-container *ngTemplateOutlet="pageButton; context: {pageIndex: page}"/>
    }
  } @else {
    <!-- First page button.  On md+ screens, we render it separately from the middle "window" so that it is always visible. -->
    @if (isMdAndUp()) {
      <ng-container *ngTemplateOutlet="pageButton; context: {pageIndex: 0}"/>
    }

    @if (showStartDots()) {
      <ng-container *ngTemplateOutlet="ellipsis"/>
    }

    <!-- Middle "window" of page number buttons. -->
    @for (page of middlePages(); track page) {
      <ng-container *ngTemplateOutlet="pageButton; context: {pageIndex: page}"/>
    }

    @if (showEndDots()) {
      <ng-container *ngTemplateOutlet="ellipsis"/>
    }

    <!-- Last page button.  On md+ screens, we render it separately from the middle "window" so that it is always visible. -->
    @if (isMdAndUp()) {
      <ng-container *ngTemplateOutlet="pageButton; context: {pageIndex: lastPage()}"/>
    }
  }
</div>

<ng-template #pageButton let-pageIndex=pageIndex>
  <button type="button" class="min-w-[1.75rem] h-[1.75rem] rounded-full justify-center items-center text-title-large px-2"
          [ngClass]="pageIndex === currentPage() ? 'bg-primary text-on-primary' : ''" (click)="selectPage(pageIndex)">
    {{ pageIndex + 1 }}
  </button>
</ng-template>

<ng-template #ellipsis><span class="text-on-surface-variant pt-1">...</span></ng-template>
